import { AppProvider } from '../../context/AppContext';   // Auth state provider
import { DBProvider } from './DBProvider';                 // Firestore provider
import { ThemeProvider } from './ThemeProvider';           // Theme + CSS vars provider

// Import global styles (order matters for overrides)
import './styling/globals.css';
import './styling/theme-light.css';
import './styling/theme-lcars.css';
import './styling/pages/pages-login.css';
import './styling/pages/pages-dashboard.css';

import type { AppProvidersProps } from '../../types/app';

/**
 * AppProviders
 *
 * Wraps the application with all global providers in a deliberate order:
 *  - ThemeProvider: sets theme classes and CSS variables on <html>
 *  - AppProvider: exposes auth state (user, loading)
 *  - DBProvider: Firestore helpers that depend on auth
 */
export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <ThemeProvider defaultTheme="dark">
      <AppProvider>
        <DBProvider>
          {children}
        </DBProvider>
      </AppProvider>
    </ThemeProvider>
  );
};

// Re-export providers for individual use if needed
export { ThemeProvider } from './ThemeProvider';
export { AppProvider } from '../../context/AppContext';
export { DBProvider } from './DBProvider';

// Re-export hooks
export { useApp } from '../../context/AppContext';

export { useTheme } from './ThemeProvider';
